import { EvaChart } from "constants/charts.enums";
import { EvaChartFeatures } from "types";

import { boxPlotFeatures } from "./boxPlot";
import { boxPlotMidstreamFeatures } from "./boxPlotMidstream";
import { cagrFeatures } from "./cagr";
import { crossPlotFeatures } from "./crossPlot";
import { crossPlotMidstreamFeatures } from "./crossPlotMidstream";
import { cumTimeFeatures } from "./cumTime";
import { declineRateFeatures } from "./declineRate";
import { injectorTotalFeatures } from "./injectorTotal";
import { materialBalanceTimeFeatures } from "./materialBalanceTime";
import { mosaicFeatures } from "./mosaic";
import { mosaicMidstreamFeatures } from "./mosaicMidstream";
import { pieFeatures } from "./pie";
import { probitFeatures } from "./probit";
import { rateCumFeatures } from "./rateCum";
import { rateDateFeatures } from "./rateDate";
import { rateDateMidstreamFeatures } from "./rateDateMidstream";
import { rateTimeFeatures } from "./rateTime";
import { recoveryPVIFeatures } from "./recoveryPVI";
import { recoveryTimeFeatures } from "./recoveryTime";
import { rigFracActivityFeatures } from "./rigFracActivity";
import { rigFracRecentActivityFeatures } from "./rigFracRecentActivity";
import { stackedBarFeatures } from "./stackedBar";
import { stackedBarHorizontalFeatures } from "./stackedBarHorizontal";
import { stackedBarMidstreamFeatures } from "./stackedBarMidstream";
import { totalRateCumFeatures } from "./totalRateCum";
import { totalRateDateFeatures } from "./totalRateDate";
import { totalRateDateMidstreamFeatures } from "./totalRateDateMidstream";
import { trendDateFeatures } from "./trendDate";
import { trendDateMidstreamFeatures } from "./trendDateMidstream";
import { wellContributionFeatures } from "./wellContribution";
import { wellStatusFeatures } from "./wellStatus";

export const FEATURE_MAP = {
  [EvaChart.RateCum]: rateCumFeatures,
  [EvaChart.RecoveryPVI]: recoveryPVIFeatures,
  [EvaChart.RecoveryTime]: recoveryTimeFeatures,
  [EvaChart.CrossPlot]: crossPlotFeatures,
  [EvaChart.CumTime]: cumTimeFeatures,
  [EvaChart.RateTime]: rateTimeFeatures,
  [EvaChart.Pie]: pieFeatures,
  [EvaChart.RateDate]: rateDateFeatures,
  [EvaChart.TotalRateDate]: totalRateDateFeatures,
  [EvaChart.TotalRateCum]: totalRateCumFeatures,
  [EvaChart.DeclineRate]: declineRateFeatures,
  [EvaChart.CAGR]: cagrFeatures,
  [EvaChart.Mosaic]: mosaicFeatures,
  [EvaChart.StackedBar]: stackedBarFeatures,
  [EvaChart.StackedBarHorizontal]: stackedBarHorizontalFeatures,
  [EvaChart.BoxPlot]: boxPlotFeatures,
  [EvaChart.Probit]: probitFeatures,
  [EvaChart.MaterialBalanceTime]: materialBalanceTimeFeatures,
  [EvaChart.TrendDate]: trendDateFeatures,
  [EvaChart.InjectorTotal]: injectorTotalFeatures,
  [EvaChart.RigFracActivity]: rigFracActivityFeatures,
  [EvaChart.RigFracRecentActivity]: rigFracRecentActivityFeatures,
  // Well Status widget — both charts share one feature set.
  [EvaChart.WellStatusOverTime]: wellStatusFeatures,
  [EvaChart.WellStatusCurrent]: wellStatusFeatures,

  // midstream charts
  [EvaChart.RateDateMidstream]: rateDateMidstreamFeatures,
  [EvaChart.TotalRateDateMidstream]: totalRateDateMidstreamFeatures,
  [EvaChart.TrendDateMidstream]: trendDateMidstreamFeatures,
  [EvaChart.CrossPlotMidstream]: crossPlotMidstreamFeatures,
  [EvaChart.WellContribution]: wellContributionFeatures,
  [EvaChart.MosaicMidstream]: mosaicMidstreamFeatures,
  [EvaChart.StackedBarMidstream]: stackedBarMidstreamFeatures,
  [EvaChart.BoxPlotMidstream]: boxPlotMidstreamFeatures
};

export function createFeatureEntities(
  type: EvaChart,
  overrides: Partial<EvaChartFeatures> = {}
): EvaChartFeatures {
  const features = FEATURE_MAP[type];
  if (!features) {
    throw new Error(`Unknown chart type: ${type} to create features`);
  }
  return features(overrides);
}
